import { render, staticRenderFns } from "./DataProcessingCopy.vue?vue&type=template&id=7421d94f&scoped=true"
import script from "./DataProcessingCopy.vue?vue&type=script&lang=js"
export * from "./DataProcessingCopy.vue?vue&type=script&lang=js"
import style0 from "./DataProcessingCopy.vue?vue&type=style&index=0&id=7421d94f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7421d94f",
  null
  
)

export default component.exports